import { defaultDirection } from '../constants/defaultValues';

Array.prototype.insert = function ( index, item ) {
  this.splice( index, 0, item );
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    const A = a[key];
    const B = b[key];
    if (order.indexOf(`${A}`) > order.indexOf(`${B}`)) {
      return 1;
    }
    return -1;
  });
  return array;
};

export function parsePrice(price) {
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' ت'
}

export function replaceServerAddress(url){
  return url.replaceAll('varzeshfarstv.com', 'tower.nikbina.ir')
}

export function getRandomBetween(min, max){
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; // January is 0!

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = `0${dd}`;
  }
  if (mm < 10) {
    mm = `0${mm}`;
  }
  return `${dd}.${mm}.${yyyy}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  return `${now.getHours()}:${now.getMinutes()}`;
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction');
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};

export const scrollToTop = () => {
  window.scrollTo({ top: 0 })
}

export const calculateTotalPrice = (total, isFirstAdd, isPlus, price) => {
  var t = Number(total)
  if (isFirstAdd) {
      t += Number(price)
  } else {
      if (isPlus) {
          t += Number(price)
      } else {
          t -= Number(price)
      }
  }
  return t
}

export const setDirection = (localValue) => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  localStorage.setItem('direction', direction);
};
